export enum LogInfoStatus {
    INITIAL_CONTACT = 'initial-contact',
    INITIAL_OFFER_SENT = 'initial-offer-sent',
    FINAL_OFFER_SENT = 'final-offer-sent',
    CONDEMNATION = 'condemnation',
    COMPLETED = 'completed'
}